<template>
  <div id="zlts">
    <div class="text">
      <!--标题-->
      <div class="topline">
        <div class="timeshell flex-box">
          <p class="title">距离本场结束还有：</p>
          <countdown :time="timenumber" @countdownClose="time_end"></countdown>
        </div>

        <ul class="time flex-box">
          <li v-for="(n, index) in times" :key="index" @click="see = index">
            <p class="p1">{{ n.t }}</p>
            <p class="p2" v-if="n.type === 1">正在进行</p>
            <p class="p2" v-else-if="n.type === 0">即将开始</p>
            <p class="p2" v-else-if="n.type === 2">已结束</p>
          </li>
          <span class="biao" :style="{left:left}"></span>
        </ul>
      </div>

      <!--商品列表-->

      <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide v-for="(n,c) in 4" :key="c">
          <ul class="item" :id="'ul'+c">
            <li class="flex-box relativeItem" v-for="(n, index) in lists[c]" :key="index">
              <router-link to="/zgdetail" class="allA"></router-link>
              <div class="i-img">
                <img src="../../assets/blankimgcover.jpg" />
              </div>
              <div class="right">
                <p class="p1">EltaMD 氨基酸清洗毛孔卸妆泡沫洁面乳温和洗面奶</p>
                <p class="p2 flex-box">
                  <span>
                    <i></i>
                  </span>已抢80%
                </p>
                <p class="p3">
                  <span class="price">
                    <i>￥</i>168.00
                  </span>
                  <span class="oprice">￥198.00</span>
                </p>
                <!-- <p class="p4 qiang">立即抢</p> -->
                <!-- <p class="p4 guo">已售罄</p> -->
                <p class="p4 coming">即将开始</p>
              </div>
            </li>
          </ul>
        </swiper-slide>
      </swiper>

      <!-- <ul class="item">
        <li class="flex-box relativeItem" v-for="(n, index) in 12" :key="index">
          <router-link to="/zgdetail" class="allA"></router-link>
          <div class="i-img">
            <img src="../../assets/blankimgcover.jpg" />
          </div>
          <div class="right">
            <p class="p1">EltaMD 氨基酸清洗毛孔卸妆泡沫洁面乳温和洗面奶</p>
            <p class="p2 flex-box">
              <span>
                <i></i>
              </span>已抢80%
            </p>
            <p class="p3">
              <span class="price">
                <i>￥</i>168.00
              </span>
              <span class="oprice">￥198.00</span>
            </p>
            <p class="p4 qiang">立即抢</p>
            <p class="p4 guo">已售罄</p>
            <p class="p4 coming">即将开始</p>
          </div>
        </li>
      </ul>-->
    </div>
  </div>
</template>

<script>
import countdown from "./countdown";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "zlts",
  components: { countdown, swiper, swiperSlide },
  data() {
    return {
      left: "0px", //标试点距离父元素左边的距离
      save_left: 0,
      t_time: "17:03:59",
      timenumber: 1582080267,
      times: [
        { t: "11:00", type: 1 },
        { t: "14:00", type: 0 },
        { t: "16:00", type: 0 },
        { t: "20:00", type: 0 }
      ],
      lists: [2, 14, 7, 4],
      see: 0,
      swiperOption: {
        speed: 300,
        // autoplay: {noSwipingSelector: 'input',
        noSwipingSelector: "ul",
        // loop: true,
        self: this,
        centeredSlides: true
      }
    };
  },
  methods: {
    //获取个人信息
    // getInfo() {
    //   let _this = this;
    //   let data = {};
    //   this.$jsonp(this.$apis("me"), data, res => {
    //     _this.info = res.data.data.result;
    //   });
    // },
    //倒计时结束
    time_end() {
      console.log("倒计时结束");
    },

    //设置标试点的默认位置
    bleft() {
      let lw = document.querySelector(".time li").clientWidth / 2;
      this.save_left = lw;
      this.left = lw + "px";
    },

    //点击时间切换设置标试点的位置
    reset_bleft() {
      let li = document
        .getElementsByClassName("time")[0]
        .getElementsByTagName("li")[this.see];
      this.left = this.save_left + li.offsetLeft + "px";
      this.swiper.slideTo(this.see, 300, false);
    },

    //循环给列表添加滑动监听时间
    add_scroll() {
      for (let i = 0; i < 4; i++) {
        let item = document.querySelector("#ul" + i);
        item.addEventListener("scroll", e => {
          let utop = e.target.scrollTop,
            sHeight = e.target.scrollHeight,
            cheight = e.target.clientHeight;
          if (sHeight - (utop + cheight) <= 50) {
            console.log(`请求#ul${i}的列表`);
          }
        });
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted: function() {
    this.$tool.setTitle("限时秒杀");
    this.bleft();
    this.add_scroll();
    //打开加载遮罩层
    this.$tool.showLoading();
  },
  watch: {
    see() {
      this.reset_bleft();
    }
  }
};
</script>








<style scoped>
#zlts {
  background: url("../../assets/zshop/zlts.jpg") no-repeat left top;
  background-size: 100%;
}
.text {
  padding-top: 17%;
  height: 100vh;
  overflow: hidden;
}
.topline {
  text-align: center;
  color: white;
}
.timeshell {
  font-size: 14px;
  justify-content: center;
  margin-bottom: 9%;
}
/**时间切换按钮 */
.time {
  position: relative;
  width: 85%;
  justify-content: space-between;
  margin: 0 auto;
  margin-bottom: 18px;
}
.time .p1 {
  font-size: 20px;
  margin-bottom: 4px;
}
.time .p2 {
  font-size: 13px;
}
.time .biao {
  position: absolute;
  content: "";
  width: 10px;
  height: 4px;
  border-radius: 3rem;
  background: white;
  bottom: -8px;
  transform: translateX(-50%);
  transition: left 0.3s;
}

/**物品列表 */
.item {
  width: 92%;
  margin: 0 auto;
  max-height: 70vh;
  min-height: 50vh;
  overflow-y: scroll;
}
.item li {
  position: relative;
  border-radius: 8px;
  background: white;
  box-shadow: 0 5px 3px rgba(41, 26, 26, 0.1);
  padding: 3.5%;
  justify-content: space-between;
  margin-bottom: 18px;
}
.item .i-img {
  width: 88px;
  height: 88px;
  overflow: hidden;
}
.item .right {
  width: 69%;
}
.item .p1 {
  font-size: 15px;
  color: #666;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.item .p2 {
  color: #ff6161;
  font-size: 10px;
  margin-top: 2px;
  margin-bottom: 10px;
}
.item .p2 span,
.item .p2 i {
  display: inline-block;
}
.item .p2 span {
  width: 37%;
  background: rgba(255, 93, 64, 0.3);
  height: 4px;
  border-radius: 3rem;
  position: relative;
  margin-right: 4px;
}
.item .p2 i {
  width: 50%;
  height: 100%;
  background: #ff6161;
  border-radius: 3rem;
  position: absolute;
  top: 0;
  left: 0;
}
.item .p2 {
  align-items: center;
}
.item .price {
  font-size: 15px;
  font-weight: bold;
  color: #ff6161;
}
.item .price i {
  font-style: normal;
  font-size: 12px;
}
.item .oprice {
  font-size: 11px;
  color: #bdbdbd;
  text-decoration: line-through;
  margin-left: 10px;
}
.item .p4 {
  position: absolute;
  right: 0;
  bottom: 15%;
  width: 25%;
  padding: 2% 0;
  text-align: center;
  font-size: 0.9rem;
  color: white;
  border-bottom-left-radius: 3rem;
  border-top-left-radius: 3rem;
}
.item .qiang {
  background: -webkit-linear-gradient(left, #ff3d4b, #ff5d40);
  background: linear-gradient(to right, #ff3d4b, #ff5d40);
}
.item .guo {
  background: rgba(255, 93, 64, 0.3);
}
.item .coming {
  background: -webkit-linear-gradient(left, #ffb31a, #ff8b3d);
  background: linear-gradient(to right, #ffb31a, #ff8b3d);
}
.allA {
  z-index: 1;
}
</style>
